module.exports = __webpack_public_path__ + "img/dashboard.61551f27.png";